const initState = {
    visibilityState: 'hidden'
};

export default function visibility(state = initState, action) {
    if (action.type === "VISIBILITY_STATE_CHANGE") {
        return {
            visibilityState: action.visibilityState
        }
    }
    return state;
}



// WEBPACK FOOTER //
// ./src/reducers/visibility.js